/**
 * @generated SignedSource<<591afc1922658f3d1a95583e905152aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomerExperienceMenuContent_helpCenter$data = {
  readonly hoistedProjectKey: string | null;
  readonly id: string;
  readonly name: {
    readonly default: string;
  } | null;
  readonly " $fragmentType": "CustomerExperienceMenuContent_helpCenter";
};
export type CustomerExperienceMenuContent_helpCenter$key = {
  readonly " $data"?: CustomerExperienceMenuContent_helpCenter$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomerExperienceMenuContent_helpCenter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CustomerExperienceMenuContent_helpCenter",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW"
    },
    {
      "concreteType": "HelpCenterName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "default"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "hoistedProjectKey"
    }
  ],
  "type": "HelpCenter"
};

(node as any).hash = "78a9ce0eeb31e4e91283984f1eb24eab";

export default node;
